import gamesGeneral from '@/store/modules/games/general';

export default {
  gamesGeneral,
};
